export default {
	close: {
		d: "M291-253.847 253.847-291l189-189-189-189L291-706.153l189 189 189-189L706.153-669l-189 189 189 189L669-253.847l-189-189-189 189Z",
		viewBox: "0 -960 960 960",
	},

	plus: {
		d: "M454.001-454.001h-194v-51.998h194v-194h51.998v194h194v51.998h-194v194h-51.998v-194Z",
		viewBox: "0 -960 960 960",
	},

	minus: {
		d: "M252.001-454.001v-51.998h455.998v51.998H252.001Z",
		viewBox: "0 -960 960 960",
	},

	ar: {
		d: "m447.846-178.924-213.692-122.23Q219.078-311 210.539-325.6q-8.538-14.599-8.538-32.015v-243.462q0-17.46 8.488-32.095 8.489-14.636 23.665-23.366l213.692-123.231q15.208-8.846 32.22-8.846 17.011 0 32.088 8.846l213.692 123.231q15.176 8.73 23.665 23.366 8.488 14.635 8.488 32.095v244.462q0 17.037-8.538 31.326-8.539 14.289-23.615 24.135l-213.692 122.23q-15.208 8.846-32.22 8.846-17.011 0-32.088-8.846Zm6.155-55.459V-465L253.999-583.386v226.771q0 3.077 1.539 5.769 1.538 2.693 4.616 4.616l193.847 111.847Zm51.998 0L699.846-346.23q3.078-1.923 4.616-4.616 1.539-2.692 1.539-5.769v-225.771L505.999-464v229.617ZM116.001-672v-107.691q0-26.923 18.843-45.615 18.842-18.693 45.465-18.693H288V-792H180.309q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847V-672h-51.999ZM288-116.001H180.309q-26.923 0-45.615-18.843-18.693-18.842-18.693-45.465V-288H168v107.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462H288v51.999Zm384 0V-168h107.691q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847V-288h51.999v107.691q0 26.923-18.843 45.615-18.842 18.693-45.465 18.693H672ZM792-672v-107.691q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H672v-51.999h107.691q26.923 0 45.615 18.843 18.693 18.842 18.693 45.465V-672H792ZM480-509.691l194.771-115.155-188.617-108.462q-3.077-1.923-6.154-1.923t-6.154 1.923L285.229-624.846 480-509.691Zm0 28.076Zm0-28.076ZM505.999-464Zm-51.998-1Z",
		viewBox: "0 -960 960 960",
	},
};

